import { connect } from 'react-redux'
import AddressItemComponent from '../components/AddressItem'
import {
  setDefaultAddress,
  fetchAllStates,
} from '../actions/ApiReqest'
import {
  switchToEditMode,
  setSelectedAddressID,
  hideDeleteAddressModal,
  showDeleteAddressModal,
} from '../actions'

const mapStateToProps = (state, ownProps) => ({
  address: ownProps.address,
  selectedAddressID: state.address.selectedAddress.id,
  showDeleteModal: state.address.showDeleteAddressModal,
  addressCount: state.address.list.length,
})

const mapDispatchToProps = (dispatch) => ({
  switchToEditMode: () => dispatch(switchToEditMode()),
  selectAddress: (id) => {
    dispatch(setSelectedAddressID(id))
    dispatch(setDefaultAddress())
  },
  setSelectedAddressID: (id) => dispatch(setSelectedAddressID(id)),
  openDeleteModal: () => dispatch(showDeleteAddressModal()),
  hideDeleteModal: () => dispatch(hideDeleteAddressModal()),
  fetchAllStates: (country) => {
    dispatch(fetchAllStates(country))
  },
})

const AddressItem = connect(mapStateToProps, mapDispatchToProps)(AddressItemComponent)

export default AddressItem
